import { render } from "./OnboardingProjectPage.vue?vue&type=template&id=7b0f898c"
import script from "./OnboardingProjectPage.vue?vue&type=script&lang=js"
export * from "./OnboardingProjectPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__